import { render, staticRenderFns } from "./teachingCat.vue?vue&type=template&id=64f9ed12&scoped=true"
import script from "./teachingCat.vue?vue&type=script&lang=js"
export * from "./teachingCat.vue?vue&type=script&lang=js"
import style0 from "./teachingCat.vue?vue&type=style&index=0&id=64f9ed12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9ed12",
  null
  
)

export default component.exports